import ClipSeasonFilterSeason from './season';
import styles from './styles.less';
import { observer, propTypes } from 'mobx-react';


function ClipSeasonFilter(props) {
    return (
        <div className={ cx(styles.root, props.className) }>
            <header className={ styles.header }>
                Season:
            </header>
            <div className={ styles.seasons }>
                { props.seasonNumbers.map(seasonNumber => (
                    <ClipSeasonFilterSeason
                        key={ seasonNumber }
                        highlightColor={ props.highlightColor }
                        number={ seasonNumber }
                        onClick={ props.onSeasonSelect.bind(null, seasonNumber) }
                        rolloverTextColor={ props.rolloverTextColor }
                        selected={ seasonNumber === props.selectedSeasonNumber }
                    />
                )) }
            </div>
        </div>
    );
}

ClipSeasonFilter.propTypes = {
    highlightColor: React.PropTypes.string,
    onSeasonSelect: React.PropTypes.func.isRequired,
    rolloverTextColor: React.PropTypes.string,
    seasonNumbers: propTypes.arrayOrObservableArray.isRequired,
    selectedSeasonNumber: React.PropTypes.number
};


export default observer(ClipSeasonFilter);



// WEBPACK FOOTER //
// ./src/show-page/components/clip-season-filter/index.js